// Garde de promesse (LOT 7 §3.4, amendé micro-complément 7b : 3 lignes —
// heure choisie · première dispo · écart estimé) — overlay MAISON, JAMAIS
// bloquant : l'outil informe, Coralie décide. Affiché au moment de Valider
// quand l'heure choisie est strictement antérieure à la première dispo estimée
// (`intenable`). Zéro écriture ici : les deux issues remontent au parent.
import { formatHeure } from '@/lib/format';

const MS_MIN = 60_000;

interface Props {
  /** Heure choisie par Coralie (epoch ms). */
  choisie: number;
  /** Première dispo estimée par le moteur (epoch ms). */
  dispo: number;
  onPrendre: () => void;
  onGarder: () => void;
}

export function GardePromesseOverlay({
  choisie,
  dispo,
  onPrendre,
  onGarder,
}: Props) {
  // Écart en minutes entières (dispo > choisie par construction — intenable).
  const ecartMin = Math.round((dispo - choisie) / MS_MIN);
  return (
    <div
      data-testid="garde-promesse"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ardoise/40 p-6"
    >
      <div className="flex w-full max-w-2xl flex-col gap-6 rounded-xl border-4 border-ardoise bg-creme p-8">
      <p className="font-cormorant text-4xl italic text-ardoise">
        Heure probablement intenable
      </p>
      <dl className="flex flex-col gap-2 font-jost text-2xl text-ardoise">
        <div className="flex justify-between gap-6">
          <dt>Heure choisie :</dt>
          <dd className="font-mono" data-testid="garde-choisie">
            {formatHeure(choisie)}
          </dd>
        </div>
        <div className="flex justify-between gap-6">
          <dt>Première dispo estimée :</dt>
          <dd className="font-mono" data-testid="garde-dispo">
            {formatHeure(dispo)}
          </dd>
        </div>
        <div className="flex justify-between gap-6">
          <dt>Écart estimé :</dt>
          <dd className="font-mono" data-testid="garde-ecart">
            {ecartMin} min
          </dd>
        </div>
      </dl>
      <div className="flex flex-col gap-4">
        <button
          type="button"
          onClick={onPrendre}
          className="min-h-[120px] rounded-lg bg-ardoise font-jost text-2xl text-creme"
        >
          Prendre {formatHeure(dispo)}
        </button>
        <button
          type="button"
          onClick={onGarder}
          className="min-h-[96px] rounded-lg border-2 border-ardoise bg-creme font-jost text-2xl text-ardoise"
        >
          Garder quand même
        </button>
      </div>
      </div>
    </div>
  );
}
